import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SharedCarouselDot.scss';

function SharedCarouselDot({ isActive, onClick }) {
    return (
        <span
            className={classNames(styles.dot, {
                [styles.activeDot]: isActive,
            })}
            onClick={onClick}
        />
    );
}

SharedCarouselDot.propTypes = {
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
};

SharedCarouselDot.defaultProps = {
    isActive: false,
    onClick: () => {},
};

export { SharedCarouselDot };
